function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Base } from "./Base";
import { ViewMounted, ViewRendered, ViewUnmounted } from "./ViewEvent";
/**
 * @deprecated
 * This class has been deprecated since v0.9.0 and will be removed in a future release.
 * It shouldn’t be used in new projects.
 */ export class Enable extends Base {
    get data() {
        return this.view.data;
    }
    set data(data) {
        throw TypeError("'data' property is readonly.");
    }
    _onRender() {
        this._setElement(this.view.element()).element();
        return super._onRender();
    }
    constructor(view){
        super();
        _define_property(this, "view", void 0);
        this.view = view;
        if (this.view.isRendered()) {
            this._onRender();
            if (document.body.contains(this.view.element())) {
                this._onMount();
            }
        } else {
            this.view.addEventListener(ViewRendered, ()=>this._onRender());
        }
        this.view.addEventListener(ViewMounted, ()=>this._onMount());
        this.view.addEventListener(ViewUnmounted, ()=>this._onUnmount());
        console.warn("[DEPRECATED] Enable class has been deprecated since v0.9.0 and will be removed in a future release. It shouldn’t be used in new projects.");
    }
}
